function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGovernanceVote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 18,
    rx: 6,
    ry: 6,
    style: {
      fill: "#ffca6f",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.6,8.47c.38,0,.69-.31,.69-.69v-.48c0-2.31-.78-3.09-3.09-3.09h-4.8c-2.31,0-3.09,.78-3.09,3.09v.24c0,.38,.31,.69,.69,.69,.28,0,.51,.23,.51,.51s-.23,.51-.51,.51c-.38,0-.69,.31-.69,.69v.23c0,2.31,.78,3.09,3.09,3.09h4.8c2.31,0,3.09-.78,3.09-3.09,0-.38-.31-.69-.69-.69-.29,0-.52-.22-.52-.5s.23-.51,.52-.51Zm-1.9,.51c0,.78,.48,1.47,1.19,1.75-.06,1-.31,1.15-1.69,1.15h-2.66v-.62c0-.38-.31-.69-.7-.69s-.69,.31-.69,.69v.62h-.75c-1.46,0-1.67-.16-1.7-1.38,.72-.29,1.2-.98,1.2-1.76s-.48-1.47-1.2-1.76c.03-1.23,.24-1.39,1.7-1.39h.75v.62c0,.38,.31,.69,.69,.69s.7-.31,.7-.69v-.62h2.66c1.5,0,1.7,.17,1.7,1.63-.72,.28-1.2,.98-1.2,1.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.49,5.42s.04,0,.05,0c.15,.01,.29,.07,.41,.15,.04,.03,.08,.06,.11,.1,.11,.13,.18,.3,.18,.48h0v4.25c0,.41-.34,.75-.75,.75s-.75-.34-.75-.75v-2.43l-4.38,4.38c-.29,.29-.77,.29-1.06,0s-.29-.77,0-1.06l4.38-4.38h-2.43c-.41,0-.75-.34-.75-.75s.34-.75,.75-.75h4.24Z",
    style: {
      fill: "#fff"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernanceVote);
export default __webpack_public_path__ + "static/media/governance_vote.4348c2f45033b31852bf4b9f4b6156b6.svg";
export { ForwardRef as ReactComponent };